import styled from 'styled-components';
import { HeaderMain } from '../../../common/typography/typography.styles';

export const AddPhoneHeader = styled(HeaderMain)`
  color: ${({ theme }) => theme.colors.baseColors.grey150};
`;

export const AuthMessageScreen = styled.div`
  display: grid;
  align-content: start;
  gap: 24px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.namedColors.white};
`;

export const AuthMessageScreenCenteredElement = styled.div`
  justify-self: center;
`;

interface ButtonsProps {
  $gap?: string;
}
export const Buttons = styled.div<ButtonsProps>`
  display: grid;
  gap: ${({ $gap = '12px' }) => $gap};

  @media screen and (min-width: 650px) {
    gap: 16px;
  }
`;

export const PhoneNumberForm = styled.form`
  display: grid;
  gap: 2.4rem;
`;
